import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cpr-range',
  templateUrl: './cpr-range.component.html',
  styleUrls: [],
  standalone: false
})
export class CpRefundRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
